module.exports = __webpack_public_path__ + "img/bank4.b6ee063c.jpg";